import React from "react";
import { Box, TextField, Typography } from "@mui/material";
import FormControl from "@mui/material/FormControl";

import { Controller } from "react-hook-form";

const TextInput = ({
  children,
  select,
  width,
  height,
  disabled,
  multiline,
  control,
  type,
  name,
  defaultValue,
  validation = {},
  isRequired,
  minLength,
  maxLength,
  inputClassName,
  maxValue,
  message,
  decimalScale = null,
  formatOnBlur = false,
  ...rest
}) => {
  const combinedValidation = {
    ...validation,
    ...(isRequired && {
      required: {
        value: true,
        message: "This field is required", // Custom message when required
      },
    }),
    ...(minLength && {
      minLength: {
        value: minLength,
        message: `The input must be at least ${minLength} characters long.`,
      },
    }),
    ...(maxLength && {
      maxLength: {
        value: maxLength,
        message: `The input can only be ${maxLength} characters long.`,
      },
    }),
    ...(maxValue && {
      validate: {
        lessThanMax: (value) => {
          // Check if the value is a number and is less than or equal to maxValue
          if (Number(value) > maxValue) {
            return message || `The value must not exceed ${maxValue}`;
          }
          return true; // Return true if validation passes
        },
      },
    }),
  };

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={combinedValidation}
      render={({ field: { onChange, value, onBlur }, fieldState: { error } }) => (
        <FormControl
          sx={{
            width: width || "18.25vw",
            borderRadius: "1px",
            minHeight: multiline ? "60px" : "auto",
          }}
          size="small"
          error={!!error}
        >
          <TextField
            sx={{
              width: width || "18.25vw",
              marginRight: select ? "1rem" : 0,
              "& .MuiOutlinedInput-root": {
                // Change border color to orange if error exists
                "&.Mui-error .MuiOutlinedInput-notchedOutline": {
                  borderColor: "orange", // Apply orange border on error
                },
                "& .MuiInputBase-root.Mui-disabled": {
                  opacity: 0.7,
                },
              },
            }}
            className={`${inputClassName}`}
            name={name}
            onChange={onChange}
            onBlur={(e) => {
              onBlur();

              if (formatOnBlur && decimalScale !== null && value !== "" && value !== null && value !== undefined) {
                const num = Number(value);

                if (!isNaN(num)) {
                  onChange(num.toFixed(decimalScale));
                }
              }

              // Preserve any existing onBlur passed via props
              if (rest.onBlur) {
                rest.onBlur(e);
              }
            }}
            // size="small"
            // variant="outlined"
            select={select}
            {...(!multiline && { type })}
            multiline={multiline}
            value={value || ""}
            minRows={multiline ? 3 : 0}
            // maxRows={multiline ? 3 : 0}
            disabled={disabled}
            error={!!error}
            {...rest}
          >
            {children}
          </TextField>
          {error && (
            <Typography variant="caption" className="error-message">
              {error.message}
            </Typography>
          )}
        </FormControl>
      )}
    />
  );
};

export default TextInput;
